module.exports = __webpack_public_path__ + "static/media/class_job_003.a7fcbff0.svg";